import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { BaseView } from '@wizeoo/akm-common-lib';

@Component({
  selector: 'user-tab-view',
  templateUrl: './user-tab.view.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserTabView extends BaseView {
 
  constructor(private route: ActivatedRoute, public elementRef: ElementRef, private cdref: ChangeDetectorRef) {
    super(elementRef);
  }

}
